import React from "react";
import {
    Alert,
    AlertTitle,
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from "@mui/material";
import bgLogin from "../../../../assets/images/bg-login.svg";
import logo from "../../../../assets/images/logo-nrecontrol.svg";
import logoFoxconn from "../../../../assets/images/logo-foxconn.svg";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {NavLink} from "react-router-dom";

const HUB_URL = process.env.REACT_APP_HUB_WEB_URL + "/login";

const DeniedAccessComponent = () => {

    const previousUrl = HUB_URL || "/";

    return (
        <div className="bg-login"
             style={{
                 backgroundImage: `url(${bgLogin})`,
                 backgroundRepeat: "no-repeat",
                 backgroundSize: "cover",
                 backgroundPosition: "center center",
                 position: "absolute",
                 bottom: 0,
                 top: 0,
                 right: 0,
                 left: 0}}>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{minHeight: "100%"}}>
                <Grid sx={{width: "400px"}}>
                    <Card elevation={4}>
                        <CardContent style={{paddingRight: "38px", paddingLeft: "38px"}}>
                            <Box
                                marginTop={4}
                                marginBottom={5}
                                component={"img"}
                                sx={{
                                    height: 32,
                                }}
                                alt="Logo Foxconn"
                                src={logo}/>
                            <Alert severity="info" sx={{fontSize: "14px"}}>
                                <AlertTitle fontWeight="bold" sx={{fontSize: "15px"}}><b>Acesso não encontrado</b></AlertTitle>
                                <span>
                                    Seu usuário ainda não possui cadastro neste sistema ou não tem permissão para acessar esta área.
                                    Para continuar, solicite a criação do seu acesso com a permissão necessária.
                                </span>
                            </Alert>

                            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: "24px", gap: "8px"}}>
                                <IconButton
                                    href={previousUrl}>
                                    <ArrowBackIcon color="secondary" fontSize="large" fontWeight="fontWeightBold"/>
                                </IconButton>
                                <Typography variant={"body1"} fontWeight="bold">
                                    VOLTAR PARA PÁGINA INICIAL DO HUB
                                </Typography>
                            </div>

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );

};

export default DeniedAccessComponent;
